import React, { useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { customerStories } from '../mock';

const CustomerStories = () => {
  const [index, setIndex] = useState(0);
  const total = customerStories.length;

  const prev = () => setIndex((i) => (i - 1 + total) % total);
  const next = () => setIndex((i) => (i + 1) % total);

  const story = customerStories[index];

  return (
    <section className="relative bg-white py-16 lg:py-24 overflow-hidden">
      <img
        src="https://www.cisco.com/content/dam/cisco-cdc/site/images/backgrounds/homepage/carousel-bg.png"
        aria-hidden
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-60 pointer-events-none"
      />
      <div className="relative max-w-7xl mx-auto px-4 lg:px-8">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0d274d] max-w-4xl leading-tight">
          Innovation in action: Real results powered by leading technology
        </h2>

        <div key={index} className="mt-12 grid lg:grid-cols-2 gap-10 items-center fade-up">
          <div className="overflow-hidden order-1 lg:order-2">
            <img src={story.image} alt={story.heading} className="w-full h-auto object-cover" />
          </div>
          <div className="order-2 lg:order-1">
            <h3 className="text-2xl md:text-3xl font-semibold text-[#0d274d] mb-5 leading-snug">
              {story.heading}
            </h3>
            <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-6">{story.description}</p>
            <a href="#" className="inline-flex items-center gap-2 text-[#0d274d] font-semibold border-b-2 border-[#00bceb] pb-1 hover:text-[#00bceb]">
              {story.cta}
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="mt-10 flex items-center gap-4">
          <button onClick={prev} className="p-3 border border-gray-300 rounded-full hover:border-[#00bceb] hover:text-[#00bceb] transition-colors" aria-label="Previous">
            <ArrowLeft className="w-4 h-4" />
          </button>
          <button onClick={next} className="p-3 border border-gray-300 rounded-full hover:border-[#00bceb] hover:text-[#00bceb] transition-colors" aria-label="Next">
            <ArrowRight className="w-4 h-4" />
          </button>
          <div className="flex gap-2 ml-4">
            {customerStories.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                className={`h-1 rounded-full transition-all ${i === index ? 'w-8 bg-[#00bceb]' : 'w-4 bg-gray-300'}`}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerStories;
